import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal from 'components/shared/StandardModal';
import { BodySmall } from 'styles/typography';

export default function NoPushDevicesModal({ onClose }: { onClose: () => void }) {
  return (
    <StandardModal title='No Devices Connected' onCancel={onClose}>
      <Content data-testid='no-push-devices-modal'>
        <Strong>Note</Strong>: You do not have any devices connected to receive push notifications. Olio will save this
        preference, and send push notifications once a device is connected.
      </Content>
      <StandardModal.Actions>
        <Button onClick={onClose}>Close</Button>
      </StandardModal.Actions>
    </StandardModal>
  );
}

const Content = styled(BodySmall)`
  display: block;
  line-height: 20px;
  margin-bottom: 40px;
`;

const Strong = styled.span`
  font-weight: 500;
`;
